<template>
    <div v-highlight>
      <pre class="language-java"><code><slot></slot></code></pre>
   </div>
</template>

<script>
// import { component as VueCodeHighlight } from 'vue-code-highlight';
import 'vue-code-highlight/themes/prism-tomorrow.css';
import 'prism-es6/components/prism-markup-templating';
import 'prism-es6/components/prism-java';
export default {
  name: 'JavaCodeBox'
}
</script>

<style scoped>
  code {
    font-size: 12px;
  }
</style>